import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33892718"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "small-card__title m-font-size" }
const _hoisted_2 = { class: "small-card__progress items-in-column" }
const _hoisted_3 = {
  key: 0,
  class: "small-card__btn-more center"
}
const _hoisted_4 = {
  key: 1,
  class: "small-card__description counters"
}
const _hoisted_5 = { class: "items-in-line flex-start" }
const _hoisted_6 = { class: "xl-font-size medium" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Объектов сдано", -1))
const _hoisted_8 = { class: "items-in-line flex-start" }
const _hoisted_9 = { class: "xl-font-size medium" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Объектов строятся", -1))
const _hoisted_11 = {
  key: 2,
  class: "small-card__description"
}

import { computed } from 'vue';
import { useAppStore } from '@/store/modules/app';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeveloperSmallCard',
  props: {
    isFull: { type: Boolean, default: false },
    developer: {}
  },
  setup(__props: any) {

const props = __props;

const showDescriptionBlock = computed(() => {
  return props.isFull && (props.developer.builtCount || props.developer.buildingCount);
});

return (_ctx: any,_cache: any) => {
  const _component_base_image = _resolveComponent("base-image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_progress_line = _resolveComponent("base-progress-line")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_divider = _resolveComponent("base-divider")!
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createBlock(_component_base_card, {
    class: _normalizeClass([{
      isFull: _ctx.isFull,

      hideDescription: !_ctx.developer.description,
    }, "small-card"]),
    "full-width-mobile": "",
    "without-mobile-shadow": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_router_link, {
        to: { name: 'developer', params: { url: _ctx.developer.url } }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_base_image, {
            src: Array.isArray(_ctx.developer.logo) ? _ctx.developer.logo[0] : _ctx.developer.logo,
            class: "small-card__img",
            contain: "",
            height: "65",
            name: "seller",
            version: "v3",
            width: "95"
          }, null, 8, ["src"])
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.developer.title), 1),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_base_progress_line, { name: "Проверка рисков" }),
        _createVNode(_component_base_progress_line, { name: "Проверка ЛПР" })
      ]),
      (_ctx.developer.id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_base_button, {
              "all-block-width": _unref(useAppStore)().getWindowWidth() <= 600,
              href: { name: 'checkResult', query: { id: _ctx.developer.id } },
              height: "36",
              text: "Подробнее",
              width: "118"
            }, null, 8, ["all-block-width", "href"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_base_divider, { class: "small-card__divider" }),
      (showDescriptionBlock.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_base_image, {
                src: require('@/assets/img/sk/icon-SK-01.png'),
                contain: "",
                height: "40",
                name: "sk1",
                width: "40"
              }, null, 8, ["src"]),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.developer.builtCount), 1),
              _hoisted_7
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_base_image, {
                src: require('@/assets/img/sk/icon-SK-02.png'),
                contain: "",
                height: "40",
                name: "sk2",
                width: "40"
              }, null, 8, ["src"]),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.developer.buildingCount), 1),
              _hoisted_10
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.developer.description)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.developer.description), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass([{
        hideDescription: !_ctx.developer.description,
      }, "center small-card__btn-link"])
      }, [
        _createVNode(_component_base_button, {
          "all-block-width": _unref(useAppStore)().getWindowWidth() <= 600,
          href: { name: 'developer', params: { url: _ctx.developer.url } },
          text: 
          _unref(useAppStore)().getWindowWidth() <= 600
            ? 'О застройщике'
            : 'На страницу Застройщика'
        ,
          height: "36",
          "style-type": "coloredBorder",
          width: "234"
        }, null, 8, ["all-block-width", "href", "text"])
      ], 2)
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})